import React from "react"
import Skeleton from "react-loading-skeleton"

const Section1Skeleton = () => {
  return (
    <div className="d-flex flex-wrap gap-3">
      <Skeleton height="94px" width="200px" />
      <Skeleton height="94px" width="200px" />
      <Skeleton height="94px" width="200px" />
    </div>
  )
}

export default Section1Skeleton
